var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2766_508",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2766_508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.74937 15.3638C10.6618 16.0487 11.7533 16.3733 12.8502 16.2861C13.9471 16.1989 14.9863 15.7049 15.8026 14.8826C16.6188 14.0603 17.1652 12.957 17.3548 11.7482C17.5443 10.5394 17.3662 9.29459 16.8487 8.21181C16.3312 7.12903 15.5041 6.27048 14.499 5.77276C13.4938 5.27503 12.3684 5.16673 11.3017 5.46507C10.2351 5.76342 9.28847 6.45128 8.61251 7.41921C7.93656 8.38713 7.57009 9.57953 7.57141 10.8067C7.57239 11.7072 7.77149 12.5937 8.15124 13.3883C8.53099 14.1829 9.07977 14.8612 9.74937 15.3638Z",
    fill: "black",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3709 15.8337C15.2997 16.9109 13.9241 17.5047 12.5 17.5047C11.0759 17.5047 9.70026 16.9109 8.62909 15.8337C5.98409 17.225 4.17859 20.0577 4.17859 23.5848V25.2005H20.8214V23.5848C20.8214 20.0498 19.0159 17.225 16.3709 15.8337Z",
    fill: "black",
    fillOpacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGrey);
export default __webpack_public_path__ + "static/media/profile-grey.ea6b7163215d3bc628bd633f6c7b68bf.svg";
export { ForwardRef as ReactComponent };